import ProjectListComponent from './project-list.component'

export default ProjectListComponent
